export default __webpack_public_path__ + "static/media/ProductsList_img5_Cn.de4318a1.webp";